import { useEffect, useState } from "react";
import dayjs from "dayjs";
import SiteClosedPage from "../../Page/SiteClosedPage";
import { useVacationsMutation } from "../../RTK/Slices/Slices/apiSliceMeat";

const VacationGuard = ({ children }) => {
    const [postVacations, { isLoading }] = useVacationsMutation();
    const [vacationInfo, setVacationInfo] = useState(null);
    const [checked, setChecked] = useState(false);

    useEffect(() => {
        postVacations()
            .unwrap()
            .then((res) => {
                const { today_is_vacation, weekends, intreval } = res || {};

                if (!today_is_vacation) {
                    setChecked(true);
                    return;
                }

                const now = dayjs();
                let info = { type: "general", reason: "", dateFrom: null, dateTo: null, dayName: null };

                // إجازات مجدولة
                if (intreval?.length > 0) {
                    const active = intreval.find((item) => {
                        const start = dayjs(item.starte_date);
                        const end = dayjs(item.end_date).endOf("day");
                        return now.isAfter(start) && now.isBefore(end);
                    }) || intreval[0];

                    if (active) {
                        info = {
                            type: "interval",
                            reason: active.description || "إجازة مجدولة",
                            dateFrom: active.starte_date || null,
                            dateTo: active.end_date || null,
                            dayName: null,
                        };
                    }
                }

                // عطلة أسبوعية
                if (info.type === "general" && weekends?.length > 0) {
                    const todayNum = now.day();
                    const todayWeekend = weekends.find((w) => w.daye_number === todayNum);
                    if (todayWeekend) {
                        info = {
                            type: "weekend",
                            reason: null,
                            dateFrom: null,
                            dateTo: null,
                            dayName: todayWeekend.daye || "اليوم",
                        };
                    }
                }

                setVacationInfo(info);
                setChecked(true);
            })
            .catch((err) => {
                console.warn("vacation fetch failed, showing site:", err);
                setChecked(true);
            });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // لسه بيحمّل
    if (isLoading || !checked) return <>{children}</>;

    // الموقع شغال
    if (!vacationInfo) return <>{children}</>;

    // في إجازة
    return <SiteClosedPage vacationInfo={vacationInfo} />;
};

export default VacationGuard;

